export default __webpack_public_path__ + "static/media/right_arrow.2e96c183.svg";